import * as React from "react";
import { changeLanguage } from "i18next";
import { useTranslation } from "react-i18next";
import { useHelperStore } from "~/stores";
import { LanguageContext, SupportedLanguages } from "~/providers/LanguageProvider";
import { Popover } from "@headlessui/react";
import Icon from "~/ui/Icon/Icon";

const LanguageSwitcher: React.FunctionComponent = () => {
    const { t } = useTranslation();
    const region = import.meta.env.VITE_REGION || "us";
    const langs: Array<SupportedLanguages> = ["en", "fr"];
    const { language, setLanguage } = React.useContext(LanguageContext);

    const isFetching = useHelperStore(state => state.isLoading);

    const changeLang = (lang: SupportedLanguages) => {
        changeLanguage(lang);
        setLanguage(lang);
    };

    return (
        region != "us" && (
            <Popover className="relative">
                <Popover.Button className="flex items-center uppercase text-stone-darkest text-sm !font-bold gap-x-3 px-4 focus:outline-none" disabled={isFetching}>
                    <img src={`/lang/${language}.png`} className="rounded-full h-5 w-5 mr-1" />
                    {language}
                    <Icon size="md" className="!text-foreground-dark">
                        keyboard_arrow_down
                    </Icon>
                </Popover.Button>
                <Popover.Panel className="absolute z-50 flex flex-col bg-white p-2 rounded-2xl shadow-md right-0 w-max mt-4">
                    {langs.map((lang: SupportedLanguages) => {
                        return (
                            <button
                                key={lang}
                                onClick={() => changeLang(lang)}
                                className="flex text-foreground-dark items-center gap-x-3 p-2 min-w-[9.375rem]"
                            >
                                <img src={`/lang/${lang}.png`} className="rounded-full h-6 w-6" />
                                <div className="grow text-left">{t(`languages.${lang}`)}</div>
                                <Icon className={lang === language ? "visible" : "invisible"}>check</Icon>
                            </button>
                        );
                    })}
                </Popover.Panel>
            </Popover>
        )
    );
};

export default LanguageSwitcher;
